import { combineReducers } from "@reduxjs/toolkit";
import { offersApi } from "../Features/Offers";
import { hotelsApi } from "../Features/Hotels";
import { countriesApi } from "../Features/Countries";
import { categoriesApi } from "../Features/Categories";
import { bookingsApi } from "../Features/Bookings";
import { discountsApi } from "../Features/Discounts";
import { regionsApi } from "../Features/Regions";
import { tagsApi } from "../Features/Tags";
import { offerOptionsApi } from "../Features/OfferOptions";
import { companiesApi } from "../Features/Companies";
import { bankAccountsApi } from "../Features/BankAccounts";
import { reservationsApi } from "../Features/Reservation";
import { applicantsApi } from "../Features/Applicants";
import { offerProgramApi } from '../Features/OfferProgram';
import { programTemplatesApi } from '../Features/ProgramTemplates';
import { offerOptionsMappingsApi } from '../Features/OfferOptionsMappings';
import { offerBoardingPlacesApi } from '../Features/OfferBoardingPlaces';
import { contractTemplatesApi } from '../Features/ContractTemplates';
import { contractsApi } from '../Features/Contracts';
import { invoicesApi } from '../Features/Invoices';
import { invoiceImportApi } from '../Features/InvoiceImport/Api/invoiceImportApi';
import { expenseInvoicesApi } from '../Features/ExpenseInvoices/Service/expenseInvoicesApi';
import { nbpApi } from '../Features/ExternalRates/Service/nbpApi';
import { cashDocumentsApi } from '../Features/CashDocuments/Service/cashDocumentsApi';
import { authApi } from '../Features/Auth/api/authApi';
import authReducer from '../Features/Auth/slices/authSlice';
import { usersApi } from '../Features/UserManagement/Service/usersApi';
import userManagementReducer from '../Features/UserManagement/slices/userManagementSlice';
import { boardingPlaceTemplatesApi } from '../Features/BoardingPlaceTemplates';
import { ksefOutgoingApi } from '../Features/KsefOutgoing';
import { ksefIncomingApi } from '../Features/KsefIncoming';
import { bankDocumentsApi } from '../Features/BankDocuments';
import { accountingExportsApi } from '../Features/AccountingExports';
import { partiesApi } from '../Features/Parties';
import { reportsApi } from '../Features/Reports';

const rootReducer = combineReducers({
  [offersApi.reducerPath]: offersApi.reducer,
  [hotelsApi.reducerPath]: hotelsApi.reducer,
  [countriesApi.reducerPath]: countriesApi.reducer,
  [categoriesApi.reducerPath]: categoriesApi.reducer,
  [bookingsApi.reducerPath]: bookingsApi.reducer,
  [discountsApi.reducerPath]: discountsApi.reducer,
  [regionsApi.reducerPath]: regionsApi.reducer,
  [tagsApi.reducerPath]: tagsApi.reducer,
  [offerOptionsApi.reducerPath]: offerOptionsApi.reducer,
  [companiesApi.reducerPath]: companiesApi.reducer,
  [bankAccountsApi.reducerPath]: bankAccountsApi.reducer,
  [reservationsApi.reducerPath]: reservationsApi.reducer,
  [applicantsApi.reducerPath]: applicantsApi.reducer,
  [offerProgramApi.reducerPath]: offerProgramApi.reducer,
  [programTemplatesApi.reducerPath]: programTemplatesApi.reducer,
  [offerOptionsMappingsApi.reducerPath]: offerOptionsMappingsApi.reducer,
  [offerBoardingPlacesApi.reducerPath]: offerBoardingPlacesApi.reducer,
  [contractTemplatesApi.reducerPath]: contractTemplatesApi.reducer,
  [contractsApi.reducerPath]: contractsApi.reducer,
  [invoicesApi.reducerPath]: invoicesApi.reducer,
  [invoiceImportApi.reducerPath]: invoiceImportApi.reducer,
  [expenseInvoicesApi.reducerPath]: expenseInvoicesApi.reducer,
  [nbpApi.reducerPath]: nbpApi.reducer,
  [cashDocumentsApi.reducerPath]: cashDocumentsApi.reducer,
  [boardingPlaceTemplatesApi.reducerPath]: boardingPlaceTemplatesApi.reducer,
  [ksefOutgoingApi.reducerPath]: ksefOutgoingApi.reducer,
  [ksefIncomingApi.reducerPath]: ksefIncomingApi.reducer,
  [bankDocumentsApi.reducerPath]: bankDocumentsApi.reducer,
  [accountingExportsApi.reducerPath]: accountingExportsApi.reducer,
  [partiesApi.reducerPath]: partiesApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  auth: authReducer,
  userManagement: userManagementReducer,
});

export default rootReducer;
